import { render } from "./Videocomponent.vue?vue&type=template&id=99f52280&scoped=true"
import script from "./Videocomponent.vue?vue&type=script&lang=js"
export * from "./Videocomponent.vue?vue&type=script&lang=js"

import "./Videocomponent.vue?vue&type=style&index=0&id=99f52280&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f52280"]])

export default __exports__